import React, { useState } from 'react';
import type { FileAuditLog } from '../types';

interface Props {
  logs: FileAuditLog[];
  onRefresh: () => void;
}

export const AuditLogView: React.FC<Props> = ({ logs, onRefresh }) => {
  const [actionFilter, setActionFilter] = useState('all');

  const filtered = actionFilter === 'all'
    ? logs
    : logs.filter((l) => l.action === actionFilter);

  const getActionBadgeClass = (action: string) => {
    switch (action) {
      case 'upload':
        return 'badge-docx';
      case 'download':
        return 'badge-xlsx';
      case 'new_version':
      case 'restore':
        return 'qa-version-pill';
      case 'archive':
        return 'badge-pdf';
      default:
        return 'qa-current-pill';
    }
  };

  return (
    <div className="audit-log-view" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
        <div>
          <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#f8fafc', margin: '0 0 0.25rem 0' }}>
            Журнал аудита операций хранилища
          </h3>
          <p style={{ color: '#94a3b8', fontSize: '0.85rem', margin: 0 }}>
            Фиксация загрузок, скачиваний, просмотра, новых версий, архивации, прав доступа и переключения AI-источника.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <select
            className="library-select"
            value={actionFilter}
            onChange={(e) => setActionFilter(e.target.value)}
          >
            <option value="all">Все действия</option>
            <option value="upload">Загрузка</option>
            <option value="download">Скачивание</option>
            <option value="preview">Просмотр</option>
            <option value="new_version">Новая версия</option>
            <option value="archive">Архивирование</option>
            <option value="restore">Восстановление</option>
            <option value="ai_toggle">Переключение AI</option>
            <option value="acl_change">Изменение прав</option>
          </select>

          <button
            type="button"
            className="action-icon-btn"
            onClick={onRefresh}
            title="Обновить журнал"
          >
            ↻ Обновить
          </button>
        </div>
      </div>

      <div className="file-table-container">
        <table className="file-table">
          <thead>
            <tr>
              <th>Время (UTC)</th>
              <th>Действие</th>
              <th>Пользователь / роль</th>
              <th>Описание</th>
              <th>IP / контекст</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>
                  События аудита не найдены
                </td>
              </tr>
            ) : (
              filtered.map((log) => (
                <tr key={log.id}>
                  <td style={{ whiteSpace: 'nowrap', fontSize: '0.8rem', color: '#94a3b8' }}>
                    {new Date(log.created_at).toLocaleString('ru-RU')}
                  </td>
                  <td>
                    <span className={`qa-badge ${getActionBadgeClass(log.action)}`} style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem' }}>
                      {log.action}
                    </span>
                  </td>
                  <td>
                    <div style={{ fontWeight: 600, color: '#f8fafc', fontSize: '0.82rem' }}>
                      {log.user_name}
                    </div>
                    <div style={{ fontSize: '0.72rem', color: '#94a3b8' }}>
                      {log.user_role}
                    </div>
                  </td>
                  <td style={{ fontSize: '0.82rem', color: '#cbd5e1' }}>
                    {log.details || '—'}
                  </td>
                  <td style={{ fontSize: '0.75rem', color: '#64748b' }}>
                    {log.ip_address}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
